// removed by extract-text-webpack-plugin
module.exports = {"sub-header":"_3WOobXzWh93mDQgZ8P9S_i","group":"B8zsGxiLdH__2Kf2KIil","similar-container":"aPqShsYJTnKlZxz6aslkY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TripDetail/SimilarTrips.scss
// module id = 1244
// module chunks = 0